
import { useTranslation } from "react-i18next";
import { TextInputControllerType1 } from "../controller/TextInputControllerType1";
import CSSClassSerivce from "../../../../services/CommonCSSSerivce";
import { IInputValidationItemProps, IInputValidatorItem } from "../../../../factorys/inputvalidation/interfaces/InputValidationInterfaces";
import { InputValidation } from "../../../../factorys/inputvalidation/InputValidation";
import InputValidationFactory from "../../../../factorys/inputvalidation/InputValidationFactory";
import { EInputValidationResultType } from "../../../../factorys/inputvalidation/enums/InputValidationEnums";

interface TextInputProps extends IInputValidationItemProps {
  keyStart?: string | null;
  readOnly?: boolean;
  label?: string;
  hideLabel?: boolean;
  testId?: string;
  name?: string;
  id?: string;
  type?: string;
  required?: boolean;
  placeholder?: string;
  classNameInput: string;
  disabledAddClass: string;
  defaultValue?: string;
  onInputChange?: ((it: string | null) => void) | null;
  disabled?: boolean | undefined;
  fOnClick?: () => void;
  fOnFocus?: () => void;
  fOnBlur?: () => void;
  onInputValidation?: ((it: EInputValidationResultType) => void) | null;
  validationItems?: IInputValidatorItem[] | null;
}

const TextInputType1: React.FC<TextInputProps> = (props) => {

  const tag = "TextInputType1"
  console.log(tag + " START");

  const { t } = useTranslation();

  //hint: if input defaultValue was undefined => user wrote some chars 
  //=> switched to another view where defaultValue is also undefinend
  //=> rendering is required and achieved by random Hash
  //let key = props.defaultValue?props.defaultValue:CommonService.getRandomHash()
  let key = props.keyStart ? props.keyStart : "" + props.defaultValue;

  //init controllers
  const c = TextInputControllerType1({
    //defaultValue: props.defaultValue,
    defaultValue: "",
    disabled: props.disabled,
    classNameFrame: "",
    classNameInput: props.classNameInput,
    disabledClass: props.disabledAddClass
  })

  const ivc = InputValidationFactory.getInputValidationController({
    validationItems: props.validationItems,
    itemProps: props,
    itemController: c,
    onMount: () => {
      ivc?.validate({ value: props.defaultValue, ignoreBlur: false })
    }
  });

  return (
    <div className="flex flex-col w-full">
      {props.hideLabel == true ?
        <label htmlFor={props.name} className={CSSClassSerivce.labelClass}>
          {t(props.label ? props.label : "")}
          <p className="pl-1">{props.required ? " *" : ""}</p>
        </label> : <></>}
      <div ref={(it) => c.setRefDiv(it)} >
        <input
          data-testid={props.testId}
          readOnly={props.readOnly ? props.readOnly : false}
          //key={props.defaultValue} //hint: keychange triggers input to reRender
          key={key} //hint: keychange triggers input to reRender
          //key={"stay"} //hint: keychange triggers input to reRender
          //data-testid={props.testId ? props.testId : props.label}
          //ref={c.refInput} //ToDo: This forces focus lose when rerender in Edge, Safari
          ref={c.refInput}
          className={props.classNameInput}
          placeholder={props.placeholder ? t(props.placeholder) : undefined}
          type={props.type ? props.type : "text"}
          id={props.name}
          name={props.name}
          required={props.required ? props.required : false}
          defaultValue={props.defaultValue}
          onClick={(e) => {
            props.fOnClick ? props.fOnClick() : null
          }}
          onFocus={(e) => {
            c.setFocused(true)
            props.fOnFocus ? props.fOnFocus() : null
          }}
          onBlur={(e) => {
            c.setFocused(false)
            c.setBlur(true)
            ivc?.strValidationIsVisible(e.target.value)
            props.fOnBlur ? props.fOnBlur() : null

          }}
          onChange={(e) => {
            try
            {
              console.log("e.target.defaultValue: " + e.target.value)
              //if(c.blur) { if(!ivc?.strIsValid(e.target.value)) return; }
              const value: string | null = e.target.value;

              ivc?.validate({ value: value });
              //(ivc != null) ? inputValidation(ivc, value) : null;
              props.onInputChange ? props.onInputChange(value) : null;

            } catch (e) { }
          }}
        />

        {(ivc != null) ? <InputValidation
          //key={key} //hint: keychange triggers input to reRender
          ivc={ivc} /> : <></>}
      </div>
    </div>
  );
};

export default TextInputType1;